module.exports = __webpack_public_path__ + "static/media/store.f590415b.png";